import React, { useState } from "react";
import "./steper.scss";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import Chip from "@mui/material/Chip";
import DeleteIcon from "@mui/icons-material/Done";
import { RootState } from "../../store/reducers";

const Steper = ({ label, labelDecs, steps, handleGoBack, stepNo, howMaysteps }: any) => {
  const state = useSelector((state: RootState) => state.appReducer);
  const { langValue } = state;
  const [isLoading] = useState(false);
  const completedStep = `familysora600 mx-2  completedStep flex-center-center`;
  const currentStep = `faimlysora600 mx-2 currentStep`;
  const comingStep = `faimlysora600 mx-2 comingStep`;

  return (
    <div >
      {isLoading ? (
        <React.Fragment>
          <div className="kanwar row m-0 mb-4 mt-3 d-flex flex-row">
            <div className="col-6  ">
              <Skeleton height={50} />
            </div>
            <div className="col-10 ">
              <Skeleton height={50} />
            </div>
            <div className="col-3 ">
              <Skeleton height={50} />
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div
          id="SteperMain"
          className={` ${
            langValue === "ar" ? `directionRt classForArabicReOrderMain` : ""
          } ${langValue == "ar" ? "arabicFamilyParent" : " "} px-2 `}
        >
          <div 
          className={`steperHeading flex-center-between ${
            langValue === "ar" ? `direction-rtl` : "direction-ltr"
          }`}>
            <h3
              className="mainHeading familysora600 mb-0"
              onClick={steps ? handleGoBack : undefined}
            >
              {" "}
              {label}
            </h3>
            {steps && (
              <span className={`d-flex  ${
                langValue === "ar" ? `direction-ltr pr-3` : "pl-3"
              }`}>
                <Chip
                  className={stepNo === 1 ? currentStep : completedStep}
                  icon={stepNo === 1 ? undefined : <DeleteIcon />}
                  label={stepNo === 1 ? "1" : ""}
                  deleteIcon={stepNo === 1 ? undefined : <DeleteIcon />}
                />
              {howMaysteps == 3 &&  <Chip
                  className={
                    stepNo === 2
                      ? currentStep
                      : stepNo === 1
                      ? comingStep
                      : completedStep
                  }
                  icon={stepNo <= 2 ? undefined : <DeleteIcon />}
                  label={stepNo <= 2 ? "2" : ""}
                  deleteIcon={stepNo === 2 ? undefined : <DeleteIcon />}
                />}

                <Chip
                  className={stepNo === 3 ? currentStep : comingStep}
                  label={howMaysteps == 3 ? "3" : '2'}
                  deleteIcon={<DeleteIcon />}
                />
              </span>
            )}
          </div>
          <div className="mt-3 ">
            <h3 className={`labelDesc familysora400 mb-0 ${langValue === "ar" ? "text-right" : "text-left"}`}>{labelDecs}</h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default Steper;
